import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker, Modal } from 'components';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { RouteComponentProps } from 'react-router-dom';
import { TestService } from 'services';
import { WarningIcon, SendIcon, LoadingGif } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Test extends React.Component<Props> {

	messagesEnd: any = null;

	state = {
		loading: true,
		consultations: [],
		form: {
			message: ''
		},
		waiting_response: false,
		chat_page: 1,
		chat_last_page: 1
	}

	async componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Probar agente',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading = false, load_more = false) => {
		await this.setState({
			loading: true
		});
		const res: any = await TestService.get({
			withoutLoading,
			page: this.state.chat_page
		});
		if (res.result) {
			this.setState({
				consultations: [
					...(res.consultations || []),
					...this.state.consultations
				],
				loading: false,
				chat_last_page: res.last_page || 1
			},() => {
				if (load_more) {
					this.scrollToTop();
				}
				else {
					this.scrollToBottom();
				}
			});
		}
	}

	send = async (e: any) => {
		e.preventDefault();
		if (!this.state.waiting_response && this.state.form.message) {
			const message = this.state.form.message;
			let consultations: any = [...this.state.consultations];
			consultations.push({
				question: message
			});
			await this.setState({
				consultations,
				waiting_response: true,
				form: {
					...this.state.form,
					message: ''
				}
			},() => this.scrollToBottom());
			const res: any = await TestService.send({
				message,
				withoutLoading: true
			});
			consultations.pop();
			consultations.push(res.consultation);
			this.setState({
				consultations,
				waiting_response: false
			},() => this.scrollToBottom());
		}
	}

	scrollToBottom = () => {
		this.messagesEnd.scrollTo({
			behavior: 'smooth',
			top: this.messagesEnd.scrollHeight
		});
	}

	scrollToTop = () => {
		this.messagesEnd.scrollTo({
			behavior: 'smooth',
			bottom: this.messagesEnd.scrollHeight
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	keydown = (e: any) => {
	  if (e.nativeEvent.keyCode == 13) {
	  	e.preventDefault();
	  	this.send(e);
	  }
	}

	loadMore = (e: any) => {
		e.preventDefault();
		this.setState({
			chat_page: this.state.chat_page + 1
		},() => this.load(true,true));
	}

	render() {
		const { loading } = this.state;

		return (
			<div id="test-ai">
				<div className="row">
					<div className="col-md-8">
						<div className="container-messages">
							<div className="container-black" ref={ (el) => { this.messagesEnd = el; } }>
								{
									this.state.chat_page < this.state.chat_last_page && (
										<div className="text-center">
											{
												loading ? (
													<i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i>
												) : (
													<a href="#" className="link-more" onClick={ (e: any) => this.loadMore(e) }>
														Cargar más mensajes
													</a>
												)
											}											
										</div>
									)
								}

								{
									this.state.consultations.map((item: any) => {
										return (
											<>
												{
													item.question && (
														<div className="item-message">
															<div style={{ width: '100%' }}>
																<p className="message">{ item.question }</p>
																<p className="date">{ moment(item.updated_at || item.created_at).format('DD/MM/YYYY HH:mm') }</p>
															</div>
														</div>
													)
												}
												{
													item.response && (
														<div className="item-message item-left">
															<div style={{ width: '100%' }}>
																<p className="message">{ item.response }</p>
																<p className="date">{ moment(item.updated_at || item.created_at).format('DD/MM/YYYY HH:mm') }</p>
															</div>
														</div>
													)
												}
											</>
										)
									})
								}

								{
									!this.state.loading && this.state.consultations.length == 0 && (
										<div className="text-center">
											<p className="no-messages">No se han encontrado mensajes</p>
										</div>
									)
								}
							</div>
							<div className="container-send">
								<Input
									value={ this.state.form.message }
									name="message"
									placeholder="Escribir"
									onKeyDown={ (e: any) => this.keydown(e) }
									onChange={ (e: any) => this.change(e) } />
								{
									this.state.waiting_response ? (
										<img src={ LoadingGif } />
									) : (
										<a href="#" onClick={ (e: any) => this.send(e) }>
											<img src={ SendIcon } />
										</a>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="container-white">
							<div className="container-warning">
								<img src={ WarningIcon } />
								<p>Aviso Importante</p>
							</div>
							<p>Para que este módulo funcione correctamente, debes haber cargado previamente información o una base de conocimiento.</p>
							<p>Esta información puede incluir:</p>
							<ul>
								<li>-Productos o servicios disponibles.</li>
								<li>-Documentos, respuestas frecuentes o datos de entrenamiento.</li>
							</ul>
							<p>Si el agente no tiene información cargada, no podrá responder ni ejecutar pruebas de manera efectiva.</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Test);